
          import "InfoCircles_11uxb28.linaria.css";
          import { styled } from "@linaria/react";
import Error from "./error-filled-16px.svg";
import Check from "./check-filled-16px.svg";
export const InfoCircle = /*#__PURE__*/styled(Error)({
  name: "InfoCircle",
  class: "i1as8aco"
});
export const WarningCircle = /*#__PURE__*/styled(Error)({
  name: "WarningCircle",
  class: "w1cwvt3f"
});
export const ErrorCircle = /*#__PURE__*/styled(Error)({
  name: "ErrorCircle",
  class: "eif8bh8"
});
export const CheckCircle = /*#__PURE__*/styled(Check)({
  name: "CheckCircle",
  class: "c3v7rpe"
});
          